export const Loading = ({ label = "Cargando…" }) => (
  <div className="flex items-center justify-center py-24" data-testid="loading-state">
    <div className="flex flex-col items-center gap-3">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-slate-200 border-t-black" />
      <span className="text-xs uppercase tracking-widest text-slate-400">{label}</span>
    </div>
  </div>
);

export const EmptyState = ({ icon: Icon, title, desc, testId }) => (
  <div
    data-testid={testId || "empty-state"}
    className="flex flex-col items-center justify-center rounded-xl border border-dashed border-slate-300 bg-white py-20 text-center"
  >
    {Icon && (
      <div className="mb-4 rounded-full border border-slate-200 bg-slate-50 p-4 text-slate-400">
        <Icon className="h-7 w-7" />
      </div>
    )}
    <h3 className="font-serif text-xl font-bold text-black">{title}</h3>
    {desc && <p className="mt-2 max-w-sm text-sm text-slate-500">{desc}</p>}
  </div>
);

export const ErrorState = ({ onRetry }) => (
  <div className="rounded-xl border border-red-200 bg-red-50 p-6 text-center" data-testid="error-state">
    <p className="text-sm font-medium text-red-700">
      No pudimos cargar los datos. Revisa tu conexión al backend.
    </p>
    {onRetry && (
      <button
        onClick={onRetry}
        className="mt-3 rounded-lg bg-black px-4 py-2 text-xs font-semibold text-white"
      >
        Reintentar
      </button>
    )}
  </div>
);

export const SectionTitle = ({ children, right }) => (
  <div className="mb-4 flex items-center justify-between">
    <h2 className="font-serif text-xl font-bold tracking-tight text-black">{children}</h2>
    {right}
  </div>
);
